import { render, staticRenderFns } from "./CardApp.vue?vue&type=template&id=6a59fb7e&scoped=true&"
import script from "./CardApp.vue?vue&type=script&lang=js&"
export * from "./CardApp.vue?vue&type=script&lang=js&"
import style0 from "./CardApp.vue?vue&type=style&index=0&id=6a59fb7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59fb7e",
  null
  
)

export default component.exports